export const withValidatedDraftEmail = <T extends { representative_email: string }>(
  payload: T,
  includeEmail: boolean
): T => {
  if (includeEmail) return payload;

  return { ...payload, representative_email: "" };
};
